import { find } from 'lodash-es';
import LenderDetailService from '../services/lender-detail-service';
import { getRefinaceLenderReviewInfo as getLenderReviewInfoSvc } from '../services/lender-review';

export default {
    data() {
        return {
            LenderOfferDetails: [],
            LenderReviewRatingDetails: [],
            CachedData: {},
        };
    },

    methods: {
        getLenderDetailsList(lenders) {
            LenderDetailService.getLenderDetailsList(lenders, this.updateLenderData);
        },
        updateLenderData(lender) {
            if (lender) {
                if (lender.lenderURlSuffix) {
                    const reviewDetails = [{ ReviewDetailsUrl: lender.lenderURlSuffix, ReviewID: lender.reviewId }];
                    this.LenderReviewRatingDetails.push({ key: lender.lenderId, value: reviewDetails });
                }
                if (lender.lenderId) {
                    this.LenderOfferDetails.push({ key: lender.lenderId, value: lender });
                    if (lender.reviewId) {
                        getLenderReviewInfoSvc(lender.lenderId, lender.reviewId).then((lenderReviewResult) => {
                            if (lenderReviewResult && lenderReviewResult.statistics) {
                                const lenderData = find(this.LenderReviewRatingDetails, element => element.value[0].ReviewID === lenderReviewResult.statistics.brandId);
                                if (lenderData) {
                                    const reviewCount = lenderReviewResult.statistics.reviewCount ? lenderReviewResult.statistics.reviewCount : 0;
                                    lenderData.value.push({ ReviewCount: reviewCount });
                                    const averageRating = parseFloat(lenderReviewResult.statistics.averageOverallRating) > 0 ? lenderReviewResult.statistics.averageOverallRating / 5.0 * 100.0 : 0;
                                    lenderData.value.push({ RatingRange: `${averageRating}%` });
                                }
                            }
                        });
                    }
                }
            }
        },
    },
};
